<h2 class="np-team__titel">{{ 'projektNeu.team.titel' | translate }}</h2>
<p class="np-team__text" data-testid="np-team-text">{{ 'projektNeu.team.text' | translate }}</p>

<div class="np-team__liste">
  <div class="np-team__zeile" data-testid="np-team-zeile">
    <span class="np-team__ich" data-testid="np-team-ich">
      <app-avatar [name]="ichName()" [size]="36" />
      <span data-testid="np-team-ich-name">{{ ichName() }}</span>
    </span>
    <span class="np-team__ich-rolle" data-testid="np-team-ich-rolle">
      {{ 'projektNeu.team.rolle.leiter.name' | translate }}
    </span>
    <span class="np-team__du" data-testid="np-team-du">{{ 'projektNeu.team.du' | translate }}</span>
  </div>
  @for (zeile of team(); track $index; let i = $index) {
    <div class="np-team__zeile" data-testid="np-team-zeile">
      <app-person-select
        class="np-team__person"
        [label]="'projektNeu.team.person' | translate"
        [options]="optionenJeZeile()[i]"
        [allowNone]="false"
        [ngModel]="zeile.personId"
        (ngModelChange)="aendern(i, { personId: $event })"
      />
      <mat-form-field appearance="fill" subscriptSizing="dynamic" class="np-feld np-feld--auswahl">
        <mat-select
          data-testid="np-team-rolle"
          [value]="zeile.rolle"
          [aria-label]="'projektNeu.team.rolleLabel' | translate"
          (selectionChange)="aendern(i, { rolle: $event.value })"
        >
          @for (r of rollen; track r.rolle) {
            <mat-option [value]="r.rolle">
              {{ 'projektNeu.team.rolle.' + r.schluessel + '.name' | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button
        type="button"
        class="np-x"
        data-testid="np-team-entfernen"
        [attr.aria-label]="'projektNeu.team.entfernen' | translate: { name: name(zeile.personId) }"
        (click)="entfernen(i)"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>
  }
</div>

@if (frei().length > 0) {
  <button
    type="button"
    class="np-textknopf np-textknopf--gross np-team__hinzufuegen"
    data-testid="np-team-hinzufuegen"
    (click)="hinzufuegen()"
  >
    {{ 'projektNeu.team.hinzufuegen' | translate }}
  </button>
}

<div class="np-team__kacheln">
  @for (r of rollen; track r.rolle) {
    <div class="np-team__kachel" data-testid="np-rolle-kachel">
      <div class="np-team__kachel-titel">{{ 'projektNeu.team.rolle.' + r.schluessel + '.name' | translate }}</div>
      <div class="np-team__kachel-text">{{ 'projektNeu.team.rolle.' + r.schluessel + '.text' | translate }}</div>
    </div>
  }
</div>
